import devConfig from "./config.dev.json"
import prodConfig from "./config.prod.json"
const config = process.env.NEXT_PUBLIC_ENV === "dev" ? devConfig : prodConfig
export default config
